import { useRef, useState } from "react";
import { ZoomIn, X } from "lucide-react";

export const ZoomImage = ({ src, alt = "", className = "aspect-[4/5]" }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 50, y: 50 });
  const [zoom, setZoom] = useState(false);
  const [open, setOpen] = useState(false);

  const onMove = (e) => {
    if (!ref.current) return;
    const r = ref.current.getBoundingClientRect();
    setPos({
      x: ((e.clientX - r.left) / r.width) * 100,
      y: ((e.clientY - r.top) / r.height) * 100,
    });
  };

  if (!src) return <div className={`${className} rounded-md bg-muted`} />;

  return (
    <>
      <div
        ref={ref}
        className={`relative ${className} overflow-hidden rounded-md bg-muted cursor-zoom-in group`}
        onMouseEnter={() => setZoom(true)}
        onMouseLeave={() => setZoom(false)}
        onMouseMove={onMove}
        onClick={() => setOpen(true)}
        data-testid="zoom-image"
      >
        <img
          src={src}
          alt={alt}
          className="h-full w-full object-cover transition-transform duration-200 will-change-transform"
          style={zoom ? { transform: "scale(2.4)", transformOrigin: `${pos.x}% ${pos.y}%` } : undefined}
        />
        <div className="absolute top-3 right-3 rounded-full bg-white/85 p-2 text-foreground/70 shadow-sm backdrop-blur pointer-events-none opacity-80 transition-opacity group-hover:opacity-100" data-testid="zoom-badge">
          <ZoomIn size={16} />
        </div>
      </div>

      {open && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4"
          onClick={() => setOpen(false)}
          data-testid="zoom-lightbox"
        >
          <button
            className="absolute right-5 top-5 text-white/80 transition-colors hover:text-white"
            onClick={() => setOpen(false)}
            aria-label="Chiudi"
            data-testid="zoom-close"
          >
            <X size={30} />
          </button>
          <img
            src={src}
            alt={alt}
            className="max-h-[92vh] max-w-[92vw] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
};
